<script>
    import TopViewSettings from "./TopViewSettings.svelte";


</script>

<div class="absolute left-0 right-0 flex top-0 px-6">
    <div class="justify-start flex-1 flex">
        top 1
    </div>
    <div class="justify-end flex-1 flex">
        top 2
    </div>
    <div class="justify-start flex-1 flex">
        top 1
    </div>
    <div class="justify-end flex-1 flex">
        <TopViewSettings />
    </div>
</div>
<div class="absolute left-0 right-0 flex bottom-0 px-6">
    <div class="justify-start flex-1 flex">
        bottom 1
    </div>
    <div class="justify-end flex-1 flex">
        bottom 2
    </div>
    <div class="justify-start flex-1 flex">
        bottom 1
    </div>
    <div class="justify-end flex-1 flex">
        bottom 2
    </div>
</div>